var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoute(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32.4516px",
    height: "40.1501px",
    viewBox: "0 0 32.4516 40.1501",
    style: {
      enableBackground: "new 0 0 32.4516 40.1501"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E25343;}\n\t.st1{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "end"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x2018_\\xCB_x201E_\\xDB_xF8FF__x2021__x5F_1_x5F__x5F_x28_x5F_\\xCD\\xD3\\xD4\\xCB_x2C7__x5F_x29_x5F__x5F_78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.0947,0.2903C1.3852,0.2903,0,1.676,0,3.3855c0,2.5791,3.0947,5.6738,3.0947,5.6738 s3.0947-3.0947,3.0947-5.6738C6.1894,1.676,4.8037,0.2903,3.0947,0.2903z M3.0947,5.4484c-1.1396,0-2.0634-0.9238-2.0634-2.063 c0-1.1396,0.9238-2.0635,2.0634-2.0635c1.1396,0,2.063,0.9239,2.063,2.0635C5.1577,4.5246,4.2343,5.4484,3.0947,5.4484z  M3.0947,2.3537c-0.5698,0-1.0317,0.4619-1.0317,1.0317c0,0.5698,0.4619,1.0317,1.0317,1.0317 c0.5698,0,1.0317-0.4619,1.0317-1.0317C4.1264,2.8157,3.6645,2.3537,3.0947,2.3537z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dot11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.21,39.9102L29.21,39.9102c-0.3506-0.0205-0.6201-0.3105-0.6006-0.6504l0,0 c0.0107-0.3496,0.3105-0.6104,0.6504-0.5996l0,0l0,0l0,0c0.3398,0.0098,0.6104,0.2998,0.5996,0.6494l0,0 c-0.0195,0.3398-0.29,0.6006-0.6299,0.6006l0,0C29.2197,39.9102,29.21,39.9102,29.21,39.9102z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "dot10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1797,39.5801c-0.3398-0.04-0.5898-0.3506-0.5498-0.6904l0,0c0.04-0.3496,0.3604-0.5898,0.7002-0.5498l0,0 c0.3398,0.04,0.5801,0.3604,0.54,0.7002l0,0c-0.0303,0.3096-0.3008,0.5498-0.6201,0.5498l0,0 C25.2295,39.5898,25.2002,39.5898,25.1797,39.5801z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "dot9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.1797,38.9102c-0.3301-0.0703-0.5498-0.4004-0.4697-0.7402l0,0c0.0698-0.3398,0.4097-0.5498,0.7397-0.4805 l0,0c0.3403,0.0801,0.5503,0.4102,0.48,0.75l0,0c-0.0601,0.29-0.3198,0.4902-0.6099,0.4902l0,0 C21.27,38.9297,21.23,38.9199,21.1797,38.9102z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "dot8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.27,37.7998c-0.3203-0.1104-0.4902-0.4697-0.3804-0.7998l0,0c0.1201-0.3203,0.4702-0.4902,0.8003-0.3701 l0,0c0.3198,0.1104,0.5,0.4697,0.3799,0.79l0,0c-0.0898,0.2598-0.3301,0.4199-0.5898,0.4199l0,0 C17.4097,37.8398,17.3398,37.8301,17.27,37.7998z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "dot7_00000057117200418396593430000016722096325581719681_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.54,36.1494c-0.3101-0.1699-0.4204-0.5498-0.25-0.8496l0,0c0.1597-0.2998,0.5396-0.4199,0.8496-0.25l0,0 c0.3003,0.1602,0.4102,0.5498,0.25,0.8496l0,0c-0.1196,0.2002-0.3296,0.3203-0.5498,0.3203l0,0 C13.73,36.2197,13.6299,36.2002,13.54,36.1494z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "dot7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1299,33.8496c-0.2603-0.2197-0.3003-0.6201-0.0801-0.8799l0,0c0.2202-0.2695,0.6201-0.2998,0.8799-0.0801 l0,0c0.27,0.2197,0.3003,0.6104,0.0801,0.8799l0,0c-0.1201,0.1504-0.2998,0.2207-0.48,0.2207l0,0 C10.3896,33.9902,10.25,33.9395,10.1299,33.8496z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "dot6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.27,30.8896c-0.21-0.2695-0.1704-0.6602,0.1099-0.8799l0,0c0.27-0.21,0.6602-0.1602,0.8701,0.1104l0,0 C8.4697,30.3994,8.4199,30.79,8.1396,31l0,0c-0.1099,0.0898-0.25,0.1299-0.3799,0.1299l0,0 C7.5698,31.1299,7.3896,31.0498,7.27,30.8896z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "dot5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.0996,27.3896c-0.1499-0.3101-0.02-0.6899,0.29-0.8398l0,0c0.3203-0.1499,0.6899-0.02,0.8403,0.29l0,0 c0.1499,0.3101,0.02,0.6899-0.29,0.8398l0,0c-0.0903,0.04-0.1802,0.0601-0.27,0.0601l0,0 C5.4297,27.7397,5.21,27.6099,5.0996,27.3896z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "dot4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.6699,23.54c-0.0903-0.3403,0.1001-0.6802,0.4399-0.77l0,0c0.3301-0.0903,0.6802,0.0996,0.77,0.4399l0,0 C4.9697,23.54,4.77,23.8799,4.4399,23.9697l0,0C4.3799,23.9897,4.3296,24,4.27,24l0,0C4,24,3.75,23.8101,3.6699,23.54z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "dot3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.8799,19.5298c-0.04-0.3501,0.1997-0.6602,0.54-0.7002l0,0c0.3398-0.0498,0.6499,0.1904,0.6997,0.54l0,0l0,0 l0,0c0.04,0.3403-0.1997,0.6504-0.54,0.7002l0,0c-0.0298,0-0.0498,0-0.0796,0l0,0C3.1899,20.0698,2.9199,19.8398,2.8799,19.5298z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "dot2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.5601,15.48c-0.0103-0.3501,0.2598-0.6401,0.6099-0.6504l0,0c0.3398-0.0098,0.6299,0.25,0.6401,0.6001l0,0 c0.0098,0.3501-0.2603,0.6304-0.6001,0.6499l0,0c-0.0103,0-0.02,0-0.02,0l0,0C2.8496,16.0796,2.5796,15.8101,2.5601,15.48z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "dot1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.4697,11.4697L2.4697,11.4697c-0.0098-0.3398,0.25-0.6299,0.6001-0.6499l0,0 c0.3398-0.0098,0.6299,0.25,0.6499,0.6001l0,0c0.0103,0.3398-0.25,0.6401-0.6001,0.6499l0,0c-0.0098,0-0.02,0-0.02,0l0,0 C2.7598,12.0698,2.48,11.8101,2.4697,11.4697z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "start"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x2018_\\xCB_x201E_\\xDB_xF8FF__x2021__x5F_1_x5F__x5F_x28_x5F_\\xCD\\xD3\\xD4\\xCB_x2C7__x5F_x29_x5F__x5F_78_00000085949848254640832760000015782680889028747681_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3569,28.0172c-1.7094,0-3.0947,1.3857-3.0947,3.0952c0,2.5791,3.0947,5.6738,3.0947,5.6738 s3.0947-3.0947,3.0947-5.6738C32.4516,29.4029,31.0659,28.0172,29.3569,28.0172z M29.3569,33.1754 c-1.1396,0-2.0634-0.9238-2.0634-2.063c0-1.1396,0.9238-2.0635,2.0634-2.0635c1.1396,0,2.063,0.9239,2.063,2.0635 C31.4199,32.2515,30.4965,33.1754,29.3569,33.1754z M29.3569,30.0806c-0.5698,0-1.0317,0.4619-1.0317,1.0317 c0,0.5698,0.4619,1.0317,1.0317,1.0317c0.5698,0,1.0317-0.4619,1.0317-1.0317C30.3886,30.5426,29.9267,30.0806,29.3569,30.0806z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoute);
export default __webpack_public_path__ + "static/media/icon-route.dbd8f2f117faea5d99ab8aaec1342519.svg";
export { ForwardRef as ReactComponent };